<template>
<section class="notice_view">

    <div class="wrap">
         <div class="news_view_info">
            <p class="title">{{ item.title }}</p>
            <div>
                <p class="view_info"><span>게시일 : {{ item.startDt }}</span><span><i class="far fa-eye"></i> {{item.viewCnt}}</span>  </p>
                <p class="news_write">
                    <img v-if="item.brandAtt" :src="item.brandAtt.url"> 
                    {{ (item.dealer) ? item.dealer.name : '' }}
                </p>
            </div>
        </div>
    </div>

    <div class="new_view_contents">

        <img v-if="item.att" :src="item.att.url"/>

        <p v-if="item.att && item.subTitle">{{ item.subTitle }}</p>

        <div class="new_content" v-html="contentView"></div>
        <!-- {{ item.content }} -->

        <a v-if="item.url" @click="openWindow(item.url)">원문보기</a>

        <button @click="$router.push('/newsList')">목록으로</button>
    </div>
</section>
</template>

<script>
import { DateFormatMixin } from '../../mixins/DateFormatMixin';

export default {
    name:'NewsInfo',
    mixins:[DateFormatMixin],
    computed: {
        boardId() {
            return this.$route.params.boardId; 
        },
        contentView() {
            let content = '';
            
            if(this.item.content) {
                content = this.item.content
                content = content.replace(/\r\n/ig, '<br>');
                content = content.replace(/\\n/ig, '<br>');
                content = content.replace(/\n/ig, '<br>');
            }

            return content;
        },
    },

    created () {
        this.$store.state.headerTitle = '파트너스 컨텐츠';
        this.getItems();
        
    },

    data() {
        return {
            item: {},
        }
    },

    methods: {
        getItems(){
            this.$store.dispatch('GET_BOARD', this.boardId)
            .then((data)=>{
                this.item = data;
                this.$store.commit('SHOW_ONLOAD');
            })
            .catch((e)=>{
                this.apiCatch(e);
                this.$store.commit('SHOW_ONLOAD');
            });
        }
    }
}
</script>
<style lang="scss" scoped>
</style>